import React from 'react'
import styles from './QualityChecklist.module.css'

const CHECKLISTS = {
  id: [
    'Full document is visible including all four corners',
    'All text is legible and not blurred',
    'No glare or reflections covering any part of the document',
    'The document is flat and not bent or folded',
  ],
  selfie: [
    'Your full face is clearly visible',
    'Good even lighting with no harsh shadows',
    'No sunglasses, hat, or anything covering your face',
    'Looking directly at the camera',
  ],
  video: [
    'Your full face is clearly visible throughout',
    'Good lighting with no harsh shadows',
    'You followed the instructions shown',
    'The video is steady and not shaky',
  ],
}

export default function QualityChecklist({ type }) {
  const items = CHECKLISTS[type] || CHECKLISTS.id

  return (
    <ul className={styles.list} aria-label="Quality checklist">
      {items.map((item, index) => (
        <li key={index} className={styles.item}>
          <span className={styles.check} aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="8" r="7.5" stroke="currentColor" strokeOpacity="0.3" />
              <path d="M5 8l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          <span className={styles.text}>{item}</span>
        </li>
      ))}
    </ul>
  )
}
